export default {
  customTitle: "常用字段", // 自定义组件头部标题
  // 表单整体默认配置
  config: {
    labelWidth: 150,
    labelPosition: "right",
    size: "small",
    customClass: "",
    ui: "element",
    layout: "horizontal",
    labelCol: 3,
    width: "100%",
    hideLabel: false,
    hideErrorMessage: false
  },
  // 基础配置
  baseSystem: {
    basicFields: [
      "input",
      "textarea",
      "number",
      "radio",
      "checkbox",
      "date",
      "time",
      "rate",
      "select",
      "switch",
      "slider",
      "text"
    ],
    advanceFields: ["table"],
    layoutFields: ["divider"],
    customFields: [
      {
        name: "审核结果",
        el: "flag",
        icon: "icon-flow icon-user-check",
        options: {
          defaultValue: "1",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: true,
          pattern: ""
        },
        rules: [
          {
            required: true,
            message: "必须填写"
          }
        ]
      },
      {
        name: "审核意见",
        el: "remark",
        icon: "icon-flow icon-shenhexitong",
        options: {
          defaultValue: "",
          width: "100%",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "附件",
        el: "uploadFile",
        icon: "icon-flow icon-wenjian",
        options: {
          defaultValue: "",
          width: "100%",
          multiple: true,
          limit: 9,
          tip: "",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "图片",
        el: "uploadImage",
        icon: "icon-flow icon-tupian",
        options: {
          defaultValue: "",
          width: "100%",
          multiple: true,
          limit: 9,
          fileSize: 5,
          tip: "只能上传jpg/png，且不超过5M",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "省-市-区",
        el: "areaSelect",
        icon: "icon-flow icon-quyu",
        options: {
          defaultValue: "",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "联系人",
        el: "contacts",
        icon: "icon-flow icon-plus",
        options: {
          defaultValue: "",
          width: "50%",
          multiple: false,
          clearable: true,
          filterable: true,
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "所属公司",
        el: "company",
        icon: "icon-flow icon-gongsi",
        options: {
          defaultValue: "",
          width: "50%",
          multiple: false,
          clearable: true,
          filterable: true,
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "所属公司及部门",
        el: "companyDepartments",
        icon: "icon-flow icon-bumenguanli",
        options: {
          defaultValue: "",
          multiple: false,
          clearable: true,
          filterable: true,
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      },
      {
        name: "人员选择",
        el: "selectUser",
        icon: "icon-flow icon-plus",
        options: {
          defaultValue: [],
          width: "50%",
          customClass: "",
          disabled: false,
          labelWidth: 100,
          isLabelWidth: false,
          hidden: false,
          dataBind: true,
          required: false,
          pattern: ""
        },
        rules: []
      }
    ]
  }
};
